import { SLOT_ELEMENT_TYPE_SYMBOL } from "@fluentui/react-utilities";

// eslint-disable-next-line no-restricted-imports
import {
  useAppFlyoutAnchor,
  type AppFlyoutAnchorState,
} from "@1js/acui-button/lib/Next";

import type { AppPreviewGalleryFlyoutAnchorProps } from "./AppPreviewGalleryFlyoutAnchor.types";
import { AppPreviewGalleryMenuButton } from "./AppPreviewGalleryMenuButton";

export const useAppPreviewGalleryFlyoutAnchor = (
  props: AppPreviewGalleryFlyoutAnchorProps,
  ref: React.Ref<HTMLButtonElement>
): AppFlyoutAnchorState => {
  const state = useAppFlyoutAnchor(props, ref);

  // We want to render a AppPreviewGalleryMenuButton instead of an AppMenuButton
  if (state.components) {
    state.components.menuButton = AppPreviewGalleryMenuButton;
    (state.menuButton as any)[SLOT_ELEMENT_TYPE_SYMBOL] =
      AppPreviewGalleryMenuButton;
  }

  state.menuButton.icon = undefined;

  return state;
};
